import {makeStyles} from '@material-ui/styles'
const useStyles = makeStyles({
    TwitteItem:{
        backgroundColor:'#ffff',
        padding:'18px',
        marginTop:'.5rem'
    },
    skeletonText:{
        marginRight:'1rem',
        marginTop:'.6rem'
    }
})
export default useStyles